<div class="sales-container">

    <div class="sales-selection">
        <mat-grid-list cols="12" [rowHeight]="rowHeight + 'px'" [gutterSize]="gutterSize + 'px'" class="form-grid">
            <mat-grid-tile class="labels">Region</mat-grid-tile>
            <mat-grid-tile class="labels">Busines View</mat-grid-tile>
            <mat-grid-tile class="labels">Sub Business View</mat-grid-tile>
            <mat-grid-tile class="labels">Lob Segment</mat-grid-tile>
            <mat-grid-tile class="labels">Channel Type</mat-grid-tile>
            <mat-grid-tile class="labels">Engine Model</mat-grid-tile>
            <mat-grid-tile class="labels">Channel</mat-grid-tile>
            <mat-grid-tile class="labels">Customer Name</mat-grid-tile>
            <mat-grid-tile class="labels">Wave Initiative</mat-grid-tile>
            <mat-grid-tile class="labels">Classification</mat-grid-tile>
            <mat-grid-tile class="labels">Product Flag</mat-grid-tile>
        </mat-grid-list>
    </div>
    <div class="sales-selection">
        <form [formGroup]="searchUserForm">
            <mat-grid-list cols="12" [rowHeight]="rowHeight + 'px'" [gutterSize]="gutterSize + 'px'"
                class="form-grid margin">

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiRegion" #region
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.financial_reporting_region }}"
                            (selectionChange)="changeFilter($event.value, 'financial_reporting_region')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchRegion" placeholderLabel="Find Region..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allRegion (click)="toggleAll('multiRegion')" value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredRegion | async" [value]="item.value"
                                (click)="tosslePerRegion('financial_reporting_region')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiBusinessView" #businessView
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.business_view }}" 
                            (selectionChange)="changeFilter($event.value, 'business_view')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchBusinessView"
                                    placeholderLabel="Find Business View..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allBusinessView (click)="toggleAll('multiBusinessView')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredBusinessView | async" [value]="item.value"
                                (click)="tosslePerBusinessView('business_view')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>



                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiSubBusinessView" #subBusinessView
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.sub_business_view }}" 
                            (selectionChange)="changeFilter($event.value, 'sub_business_view')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchSubBusinessView"
                                    placeholderLabel="Find Sub Business View..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allSubBusinessView (click)="toggleAll('multiSubBusinessView')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredSubBusinessView | async" [value]="item.value"
                                (click)="tosslePerSubBusinessView('sub_business_view')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiLobSegment" #logSegment
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.lob_segment_2 }}" 
                            (selectionChange)="changeFilter($event.value, 'lob_segment_2')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchLobSegment"
                                    placeholderLabel="Find LobSegment..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allLobSegment (click)="toggleAll('multiLobSegment')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredLobSegment | async" [value]="item.value"
                                (click)="tosslePerLobSegment('lob_segment_2')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiChannelType" #channelType
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.type }}" 
                            (selectionChange)="changeFilter($event.value, 'type')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchChannelType"
                                    placeholderLabel="Find Customer..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allChannelType (click)="toggleAll('multiChannelType')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredChannelType | async" [value]="item.value"
                                (click)="tosslePerChannelType('type')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiEngineModel" #engineModel
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.revised_product_family_standard }}" 
                            (selectionChange)="changeFilter($event.value, 'revised_product_family_standard')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchEngineModel"
                                    placeholderLabel="Find Engine Model..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allEngineModel (click)="toggleAll('multiEngineModel')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredEngineModel | async" [value]="item.value"
                                (click)="tosslePerEngineModel('revised_product_family_standard')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiChannel" #channelNew
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.channel_new }}" 
                            (selectionChange)="changeFilter($event.value, 'channel_new')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchChannel" placeholderLabel="Find channel ..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allChannel (click)="toggleAll('multiChannel')" value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredChannel | async" [value]="item.value"
                                (click)="tosslePerChannel('channel_new')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiCustomerName" #customerName
                            [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.revised_customer_name }}" 
                            (selectionChange)="changeFilter($event.value, 'revised_customer_name')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchCustomerName"
                                    placeholderLabel="Find Customer..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allCustomerName (click)="toggleAll('multiCustomerName')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredCustomerName | async" [value]="item.value"
                                (click)="tosslePerCustomerName('revised_customer_name')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiWaveInitiative"
                            #waveInitiative [matTooltipClass]="'my-tooltip'"
                            matTooltip="{{ selectedValues.wave_initiative }}" 
                            (selectionChange)="changeFilter($event.value, 'wave_initiative')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchWaveInitiative"
                                    placeholderLabel="Find wave_initiative..."
                                    noEntriesFoundLabel="'no matching ECC found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allWaveInitiative (click)="toggleAll('multiWaveInitiative')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredWaveInitiative | async" [value]="item.value"
                                (click)="tosslePerWaveInitiative('wave_initiative')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiClassification"
                            #classification [matTooltipClass]="'my-tooltip'"
                            matTooltip="{{ selectedValues.classification }}" 
                            (selectionChange)="changeFilter($event.value, 'classification')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchClassification"
                                    placeholderLabel="Find Classification..."
                                    noEntriesFoundLabel="'no matching Classification found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allClassification (click)="toggleAll('multiClassification')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredClassification | async" [value]="item.value"
                                (click)="tosslePerClassification('classification')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile class="select">
                    <mat-form-field appearance="outline">
                        <mat-select multiple placeholder="All" formControlName="multiProductFlag"
                            #productFlag [matTooltipClass]="'my-tooltip'"
                            matTooltip="{{ selectedValues.productFlag }}" 
                            (selectionChange)="changeFilter($event.value, 'productFlag')">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="searchProductFlag"
                                    placeholderLabel="Find Product Flag..."
                                    noEntriesFoundLabel="'no matching ProductFlag found'"></ngx-mat-select-search></mat-option>
                            <mat-option #allProductFlag (click)="toggleAll('multiProductFlag')"
                                value="All">All</mat-option>
                            <mat-option *ngFor="let item of filteredProductFlag | async" [value]="item.value"
                                (click)="tosslePerProductFlag('productFlag')">
                                {{ item.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <span (click)="resetFilter()" class="reset"><img
                            src="../../../../../assets/images/clear.png" />&nbsp; RESET
                        FILTERS</span></mat-grid-tile>
            </mat-grid-list>
        </form>
    </div>
</div>